var render, staticRenderFns
import script from "./UiRowButton.vue?vue&type=script&lang=js"
export * from "./UiRowButton.vue?vue&type=script&lang=js"
import style0 from "./UiRowButton.vue?vue&type=style&index=0&id=cd9a9a54&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports